import type { VimeoVideo } from 'src/graphql/generated/graphql';

interface VideoPlayerProps {
  description?: string;
  video: Partial<VimeoVideo>;
  className?: string;
}

export const VideoPlayer = ({
  description,
  video,
  className,
}: VideoPlayerProps) => {
  const playerEmbedHtml = video.playerEmbedHtml || '';

  return (
    <div className={className}>
      {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
      <div dangerouslySetInnerHTML={{ __html: playerEmbedHtml }} />
    </div>
  );
};
